import { render } from "./SidenavCollapse.vue?vue&type=template&id=0c429479"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__